export var PERPETUAL_BOND_DEFINITION_KEY = 'perpetualBondDefinition';
export var PERPETUAL_BOND_VARIATION_KEY = 'perpetualBondVariation';
export var PERPETUAL_BOND_CALL_KEY = 'perpetualBondCall';
